import React from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

import AccountValidationPopup from '../pages/popup/AccountValidationPopup';
import AdminLogin from '../pages/admin/Login';
// [APP-FORK] 앱 점주 검증 QR 진입 페이지 (naegift://verify/{uuid} → /app/qr/:type/:uuid)
import AppQrEntry from '../pages/admin/AppQrEntry';
// [APP-FORK] QR 웹URL 랜딩(외부 카메라 폴백) — /app/link/:type/:uuid → 딥링크/스토어 유도
import AppLinkLanding from '../app/AppLinkLanding';
import AppOnlyGuard from '../app/AppOnlyGuard';
import AdminLoginGlobal from '../pages/admin/AdminLoginGlobal';
import Status from '../pages/admin/Status';
import MyInfo from '../pages/admin/MyInfo';
import NoticeBoard from '../pages/admin/NoticeBoard';
import Verification from '../pages/admin/Verification';
import VerifyConfirm from '../pages/admin/VerifyConfirm';
import VerifyFailure from '../pages/admin/VerifyFailure';
import VerifyInvalid from '../pages/admin/VerifyInvalid';
import VerifySuccess from '../pages/admin/VerifySuccess';
import GiftContent from '../pages/gift/giftContent.js';
import GiftList from '../pages/gift/giftList.js';
import GiftManage from '../pages/gift/giftManage.js';
import GiftSales from '../pages/gift/giftSales.js';
import Login from '../pages/login/login.js';
import MarketingManage from '../pages/marketingManage.js';
import QnaContent from '../pages/qna/qnaContent.js';
import QnaList from '../pages/qna/qnaList.js';
import QnaManage from '../pages/qna/qnaManage.js';
import QnaModify from '../pages/qna/qnaModify.js';
import GiftRefund from '../pages/refund/giftRefund.js';
import StoreManage from '../pages/store/storeManage.js';
import UserManage from '../pages/user/userManage.js';
import UserWithdrawal from '../pages/user/userWithdrawal.js';
import StaffManage from '../pages/user/staffManage.js';
import CustomerManage from '../pages/customer/customerManage.js';
import StoreGuide from '../pages/manual/StoreGuide.js';
export default function Router() {
  return (
    <Routes>
      <Route path="/" element={<Login />} />

      <Route path="/login" element={<Login />} />

      <Route path="/store-guide" element={<StoreGuide />} />

      <Route path="/popup/account-validation" element={<AccountValidationPopup />} />

      <Route path="/:storeNo/user-manage" element={<UserManage />} />
      <Route path="/:storeNo/staff-manage" element={<StaffManage />} />

      <Route path="/:storeNo/user-withdrawal" element={<UserWithdrawal />} />

      <Route path="/:storeNo/store-manage" element={<StoreManage />} />
      <Route path="/:storeNo/customer-manage" element={<CustomerManage />} />
      <Route path="/:storeNo/gift-list" element={<GiftList />} />
      <Route path="/:storeNo/gift-refund" element={<GiftRefund />} />

      <Route path="/:storeNo/gift-content" element={<GiftContent />} />
      <Route path="/:storeNo/gift-manage" element={<GiftManage />} />
      <Route path="/:storeNo/gift-sales" element={<GiftSales />} />
      <Route path="/:storeNo/qna-list" element={<QnaList />} />
      <Route path="/:storeNo/qna-content" element={<QnaContent />} />
      <Route path="/:storeNo/qna-manage" element={<QnaManage />} />
      <Route path="/:storeNo/qna-modify" element={<QnaModify />} />
      <Route path="/:storeNo/marketing-manage" element={<MarketingManage />} />

      {/* AdminLogin only */}
      <Route
        path="/admin/login/:storeNo/:memberGiftNo"
        element={<AdminLogin />}
      />
      <Route
        path="/admin/login/:storeNo/:memberGiftNo/:giftNo"
        element={<AdminLogin />}
      />

      {/* [신규] storeNo 모르는 상태의 글로벌 진입점(마켓 "상점관리자" 메뉴) — 기존 아래
          /mobile/login/:storeNo(Login.js)는 그대로 두고 별도 라우트로 추가. */}
      <Route path="/mobile/login" element={<AdminLoginGlobal />} />

      {/* Mobile-prefixed AdminLogin aliases */}
      <Route path="/mobile/login/:storeNo" element={<AdminLogin />} />
      <Route
        path="/mobile/login/:storeNo/:memberGiftNo"
        element={<AdminLogin />}
      />
      <Route
        path="/mobile/login/:storeNo/:memberGiftNo/:giftNo"
        element={<AdminLogin />}
      />

      {/* Admin mobile gift status */}
      <Route
        path="/mobile/giftstatus/:storeNo"
        element={<Navigate to="home" replace />}
      />
      <Route path="/mobile/giftstatus/:storeNo/:tab" element={<Status />} />
      <Route path="/mobile/myinfo/:storeNo" element={<MyInfo />} />
      <Route path="/mobile/notice" element={<NoticeBoard />} />
      <Route path="/mobile/verification/:storeNo" element={<Verification />} />
      <Route
        path="/mobile/verifyconfirm/:storeNo/:memberGiftNo/:giftNo"
        element={<VerifyConfirm />}
      />
      {/* [APP-FORK] 앱 전용 — 검증은 앱 스캐너로만 하므로 웹 접근을 막는다. */}
      <Route
        path="/mobile/verifysuccess/:storeNo/:memberGiftNo/:giftNo"
        element={
          <AppOnlyGuard>
            <VerifySuccess />
          </AppOnlyGuard>
        }
      />
      <Route
        path="/mobile/verifyfailure/:storeNo/:memberGiftNo/:giftNo"
        element={<VerifyFailure />}
      />

      <Route path="/mobile/verifyinvalid" element={<VerifyInvalid />} />

      {/* [APP-FORK] 앱 검증 QR 진입 (/app/ 접두사 → 기존 라우트와 충돌 없음) */}
      <Route path="/app/qr/:type/:uuid" element={<AppQrEntry />} />

      {/* [APP-FORK] QR 웹URL 랜딩(외부 카메라 폴백). 앱 스캐너는 /app/qr로 직행하므로 미경유 */}
      <Route path="/app/link/:type/:uuid" element={<AppLinkLanding />} />
    </Routes>
  );
}
